"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Radio = _interopRequireDefault(require("@mui/material/Radio/Radio.js"));

var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles/makeStyles.js"));

var _Colors = _interopRequireDefault(require("../../styles/Colors"));

var _FormControlLabel = _interopRequireDefault(require("../FormControlLabel"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var useStyle = (0, _makeStyles.default)({
  root: {
    padding: 0
  },
  icon: {
    width: 23,
    height: 23,
    borderRadius: '50%',
    border: "1px solid ".concat(_Colors.default.lightGrey),
    backgroundColor: _Colors.default.white
  },
  checkedIcon: function checkedIcon(_ref) {
    var disabled = _ref.disabled;
    return {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: 23,
      height: 23,
      borderRadius: '50%',
      border: "1px solid ".concat(_Colors.default.orange),
      opacity: disabled ? '0.5' : '1',
      backgroundColor: _Colors.default.white,
      '& div': {
        width: 15,
        height: 15,
        borderRadius: '50%',
        backgroundColor: _Colors.default.orange
      }
    };
  }
});

var Radio = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var disabled = props.disabled,
      readOnly = props.readOnly;
  var disabledOrReadonly = disabled || readOnly;
  var classes = useStyle({
    disabled: disabledOrReadonly
  });
  var root = classes.root,
      icon = classes.icon,
      checkedIcon = classes.checkedIcon;
  return /*#__PURE__*/_react.default.createElement(_FormControlLabel.default, _extends({
    ref: ref,
    control: /*#__PURE__*/_react.default.createElement(_Radio.default, {
      color: "default",
      classes: {
        root: root
      },
      disableRipple: true,
      inputProps: {
        readOnly: readOnly
      },
      icon: /*#__PURE__*/_react.default.createElement("div", {
        className: icon
      }),
      checkedIcon: /*#__PURE__*/_react.default.createElement("div", {
        className: checkedIcon
      }, /*#__PURE__*/_react.default.createElement("div", null))
    })
  }, props));
});

var _default = Radio;
exports.default = _default;